import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicComponent, PUBLIC_ROUTES } from './layout/public';
import { PublicGuard } from './core/guards/public.gaurd';
import { AuthGuard } from './core/guards/auth.guard';
import { PrivateComponent, PRIVATE_ROUTES } from './layout/private';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { ContactUsComponent } from './shared/components/contact-us/contact-us.component';
import { SignoutComponent } from './shared/components/signout/signout.component';
import { MaintenanceComponent } from './user/components/maintenance/maintenance.component';

const routes: Routes = [
  {
    path: 'not-found',
    pathMatch: 'full',
    component: NotFoundComponent,
    data: { breadcrumb: 'Not Found' },
  },
  {
    path: 'signout',
    pathMatch: 'full',
    component: SignoutComponent,
    data: { breadcrumb: 'Not Found' },
  },
  { path: 'contact-us', component: ContactUsComponent },
  {
    path: '',
    component: PublicComponent,
    canActivate: [PublicGuard],
    data: { title: 'Public Views' },
    children: PUBLIC_ROUTES,
  },
  {
    path: '',
    component: PrivateComponent,
    canActivate: [AuthGuard],
    data: { title: 'Secure Views' },
    children: PRIVATE_ROUTES,
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent,
    canActivate: [PublicGuard, AuthGuard],
  },
  { path: '**', redirectTo: '/not-found' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled', // or 'top'
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
